import { IFeriado } from "../../../Interfaces/Geral/Feriado/FeriadoInterface";
import {
    AtualizarFeriadoService,
    CadastrarFeriadoService,
    DeletarFeriadoService,
    ListarFeriadosService,
    ListarTiposFeriadosService,
} from "../../../Services/Geral/Feriado/FeriadoService";
import { Controller } from "../../Controller";

export async function ListarTiposFeriadosController() {
    return Controller(ListarTiposFeriadosService());
}

export async function CadastrarFeriadoController(requestBody: IFeriado) {
    return Controller(CadastrarFeriadoService(requestBody));
}

export async function AtualizarFeriadoController(
    id: number,
    requestBody: IFeriado
) {
    return Controller(AtualizarFeriadoService(id, requestBody));
}

export async function ListarFeriadosController() {
    return Controller(ListarFeriadosService());
}

export async function DeletarFeriadoController(id: number) {
    return Controller(DeletarFeriadoService(id));
}
